export default {
	"Main menu": {
		Login: "Zaloguj",
		Logout: "Wyloguj",

		Documents: {
			Title: "Dokumenty",
			List: "Lista",
		},

		Account: {
			Title: "Moje konto",
			"Customer data": "Dane klienta",
			"Passwords complexity": "Złożoność haseł",
			"Integration method": "Metoda integracji",
			"Domain settings": "Ustawienia domeny",
			"Login method for end clients": "Metoda zakładania klientów końcowych",
			"Modules permissions": "Uprawnienia modułów",
			"Creation method": "Metoda tworzenia",
			"Customer user": "Twoje dane",
			"Company info": "Dane firmy",
			Notification: "Powiadomienia",
			"Password change": "Zmiana hasła",
			Visualization: "Wizualizacja",
			"Smtp settings": "Ustawienia SMTP",
			Contact: "Kontakt",
			"Contact type": "Typ kontaktu",
			"Browsers list": "Lista przeglądarek",
		},

		CustomerAccounts: {
			Title: "Subkonta",
			List: "Lista",
			"Account details": "Nowy klient",
			Edit: "Edycja",
			"New account": "Nowe Konto",
		},

		Messages: {
			Title: "Komunikaty",
			List: "Lista",
			"New message": "Nowa wiadomość",
			Edit: "Edycja",
		},

		Reports: {
			Title: "Raporty",
			Documents: "Statystyki dokumentów",
			Authentications: "Statystyki logowań",
			Messages: "Statystyki komunikatów",
		},

		Subcustomers: {
			Title: "Klienci końcowi",
			List: "Lista",
			"New account": "Nowy klient",
			Edit: "Edycja",
		},

		MailTemplate: "Szablon wiadomości e-mail",
	},

	Buttons: {
		Common: {
			Close: "Zamknij",
			Back: "Wstecz",
			Next: "Dalej",
			Save: "Zapisz",
			Cancel: "Anuluj",
			"Change password": "Zmień hasło",
			Reset: "Resetuj",
			Send: "Wyślij",
			Search: "Szukaj",
			Login: "Zaloguj",
			New: "Nowy",
			Accept: "Akceptuj",
			"Excel Export": "Eksportuj do Excel",
			"Pdf Export": "Eksportuj do PDF",
			"Unblock share": "Odblokuj",
			"New code": "Generuj nowy kod",
			"Go to application": "Przejdź do serwisu",
			"Microsoft Login": "Zaloguj do konta Microsoft",
		},

		Customerusers: {
			"Account details": {
				"Create account": "Utwórz użytkownika",
			},
		},

		Subcustomers: {
			"Account details": {
				"Create account": "Utwórz konto klienta",
				"Create user account": "Utwórz konto właściciela",
				"Save visualization": "Zapisz wizualizację",
			},
		},

		Messages: {
			"Add message": "Dodaj wiadomość",
		},
	},

	Labels: {
		Account: {
			"Password change": {
				"Old password": "Stare hasło",
				"New password": "Nowe hasło",
				"New password repeat": "Nowe hasło (powtórzenie)",
			},

			"Contact type": {
				Table: {
					Name: "Nazwa",
					Email: "E-mail",
				},
			},

			"Browsers List": {
				Table: {
					Id: "Identyfikator",
					Code: "Kod",
					ClientID: "ID Przeglądarki",
					"Expiration Date": "Data wygaśnięcia",
					Actions: "Akcje",
				},
			},
		},

		"Auth code form": {
			Title: "Wprowadź kod autoryzacji",
			"Auth code": "Kod autoryzacji",
			Remember: "Zapamiętaj",
		},

		"Change password form": {
			Title: "Zmiana hasła",
			"New password": "Nowe hasło",
			"New password confirmation": "Nowe hasło (powtórzenie)",
		},

		Common: {
			Yes: "Tak",
			No: "Nie",
			Email: "E-mail",
			SMS: "SMS",
			Contact: "Kontakt",
			Name: "Nazwa",
			New: "Nowy",
			Edit: "Edycja",
			Table: {
				Actions: "Akcje",
			},
		},

		"Contact form": {
			Title: "Kontakt",
			"Add attachment": "Dodaj załącznik",
			"Message title": "Tytuł wiadomości",
			Content: "Treść wiadomości",
			"Form of contact": "Preferowana forma kontaktu",
			"Send copy by email": "Wyślij kopię na maila",
		},

		Customer: {
			"Account details": {
				"Customer data": {
					Title: "Dane klienta",
					Firstname: "Imię",
					Lastname: "Nazwisko",
					Login: "Login",
					Password: "Hasło inicjalne",
					Email: "E-mail",
					Phone: "Numer telefonu",
				},

				Visualization: {
					Title: "Wizualizacja",
					Logo: "Logo",
					Footer: "Stopka",
					Background: "Grafika w tle",
					Favicon: "Favicon",
					"Footer content": "Treść stopki",
					"Welcome content": "Treść powitania",
					"Header content": "Treść nagłówka",
					"Font color": "Kolor fontów",
					"Font button color": "Kolor fontu przycisków",
					"Button color": "Kolor przycisków",
					"Menue color": "Kolor menu",
					"Menue font color": "Kolor fontu menu",
					"Accent color": "Kolor akcentu",
					"Header footer color": "Kolor nagłówka stopki",
					"Background color": "Kolor tła",
					"Link color": "Kolor odnośników",
					"Checkbox color": "Kolor checkboxów i radiobuttonów",
					"Placeholders color": "Kolor placeholdera",
				},

				Notifications: {
					"Setting new document": "Wystawienie nowego dokumentu",
					Invoice: "Faktura",
					Balance: "Saldo",
					Agreement: "Umowa",
					Payment: "Płatność",
					"Incoming payments": "Płatności nadchodzące",
					"Expired payments": "Płatności przeterminowane",
					"Platform management": "Zarządzanie platformą",
					"Password change": "Zmiana hasła",
					"Login failed": "Nieudana próba logowania",
					"Upcoming Payment Days Before": "Ilośc dni przed terminem płatności:",
					"SMTP login success": "Poczta została skonfigurowana",
					"SMTP login failed": "Poczta nie została skonfigurowana",
				},

				"Creation method": "Metoda tworzenia",

				"Basic info": "Dane podstawowe",
				"Address for correspondence": "Adres korespondencyjny",
				"Contact info": "Dane kontaktowe",
				"Owner info": "Dane właściciela",

				Authorization: "Autoryzacja",
				Identifier: "Identyfikator",
				Name: "Nazwa pełna",
				"Short name": "Nazwa krótka",
				City: "Miasto",
				"Post code": "Kod pocztowy",
				Street: "Ulica",
				NIP: "NIP",
				Address: "Adres",
				"Firstname lastname": "Imię i nazwisko",
				Login: "Login",
				"Init password": "Hasło inicjalne",
				Email: "E-mail",
				"Email for send": "E-mail do wysyłki",
				Phone: "Numer telefonu",
				"Contact person": "Osoba kontaktowa",

				"Change password on first login":
					"Zmień hasło podczas pierwszego logowania",

				"SMTP address": "Adres serwera SMTP",
				"SMTP port": "Port",
				"SMTP encryption": "Rodzaj szyfrowania",
				"SMTP username": "Email użytkownika",
				"SMTP user name": "Nazwa użytkownika",
				"SMTP password": "Hasło",
				"SMTP sender name": "Nazwa nadawcy",
				"SMTP sender email": "Email nadawcy",
				"SMTP protocol": "Protokół",
				"SMTP test email": "Email na który zostanie wysłany email testowy",
				"SMTP test": "Test połączenia",
				"SMTP test success": "Testowy email został wysłany",
				"SMTP test error": "Nie udało się wysłać emaila",
				"SMTP Type": "Obsługa poczty",
				"SMTP type standard": "Standard",
				"SMTP type Microsoft 365": "Microsoft 365",
				"SMTP office 365 configured": "Poczta została skonfigurowana",
			},
		},

		CustomeruserType: {
			OWNER: "Właściciel",
			ANALYST: "Analityk",
			ACCOUNTANT: "Księgowy",
		},

		Customerusers: {
			Table: {
				Type: "Typ",
				Name: "Imię i nazwisko",
				"Creation date": "Data utworzenia",
				Actions: "Akcje",
				"Confirm block": "Czy zablokować użytkownika?",
				"Confirm unblock": "Czy odblokować użytkownika?",
			},

			"Account details": {
				Type: {
					Type: "Typ",
					Owner: "Właściciel",
					Analyst: "Analityk",
					Accountant: "Księgowy",
				},

				Firstname: "Imię",
				Lastname: "Nazwisko",
				Login: "Login",
				Password: "Hasło",
				Email: "E-mail",
				Phone: "Telefon",
				"Change password on first login":
					"Zmień hasło podczas pierwszego logowania",
			},
		},

		Documents: {
			"Date from": "Data od",
			"Date to": "Data do",
			"Creation Date": "Data utworzenia:",
			"First Download Date": "Data pierwszego pobrania:",

			InvoiceDocumentType: {
				INVOICE: "Faktura",
				INVOICE_CORRECTION: "Faktura korygująca",
			},

			DocumentStatus: {
				NEW: "Nowy",
				DOWNLOADED: "Pobrany",
			},

			Table: {
				Type: "Typ dokumentu",
				Name: "Id dokumentu",
				"Creation date": "Data przesłania",
				"First download date": "Data pierwszego odczytania pliku",
				"Subcustomer name": "Klient Końcowy nazwa",
				NIP: "NIP",
				NetAmount: "Kwota netto",
				GrossAmount: "Kwota brutto",
				Currency: "Waluta",
				"Document status": "Status dokumentu",

				"Subcustomer identifier": "Identyfikator",
				FirstDownloadSubcustomerUserLogin:
					"Login użytkownika który pierwszy pobrał dokument",
				"Invoice date": "Data wystawienia",
				"Sell date": "Data sprzedaży",
				"Payment date": "Data płatności",
				"Payment status": "Status płatności",
			},
		},

		"Login form": {
			identifier: "Identyfikator",
			Login: "Login",
			Password: "Hasło",
			"Reset password": "Zresetuj hasło",
			LogIn: "Zaloguj",
			Language: "Język",
		},

		Messages: {
			Form: {
				Type: "Typ",
				Mode: "Rodzaj",
				Role: "Rola",
				Priority: "Priorytet",
				Title: "Tytuł komunikatu",
				Content: "Treśc komunikatu",
				"Date from": "Data od",
				"Date to": "Data do",
				AgreementText: "Etykieta potwierdzenia",
			},

			Table: {
				Title: "Tytuł",
				SubjectType: "Typ",
				ServiceType: "Rodzaj",
				Roles: "Role",
				"Creation date": "Data dodania",
				"Date start": "Data początkowa",
				"Date stop": "Data końcowa",
				Priority: "Priorytet",
				Status: "Status",
				Actions: "Akcje",
				Details: "Sczcegóły komunikatu",
			},

			Modal: {
				"Accept rules": "Zapoznałem się i akceptuję komunikat",
				"Confirm info": "Aby przejść do serwisu musisz zaakceptować warunki",
			},
		},

		MessageSubjectType: {
			REGULATIONS: "Regulamin",
			RODO: "Rodo",
			OTHER: "Inny",
		},

		MessageServiceType: {
			REQUIRED: "Obowiązkowy",
			PERMANENT: "Permanentny",
			OPTIONAL: "Opcjonalny",
		},

		MessageTargetUserType: {
			OWNER: "Właściciel",
			POWER_USER_ANALYST: "Analityk",
			ACCOUNTANT: "Księgowy",
			EMPLOYEE: "Pracownik",
		},

		MessageStatus: {
			ACTIVE: "Aktywny",
			INACTIVE: "Nieaktywny",
		},

		"Password reset": {
			Title: "Resetowanie hasła",
			Statement1: "Aby zresetować hasło podaj dane logowania",
			"Request failed": "Nie udało się wysłać żądania zmiany hasła",
			"Request success": "Wysłano na adres e-mail link do zmiany hasła",
			"Reset success": "Hasło zostało zmienione",
			"Login again": "Przejdź do strony logowania",
		},

		Subcustomer: {
			"Account details": {
				"Basic info": "Dane podstawowe",
				"Address for correspondence": "Adres korespondencyjny",
				"Contact info": "Dane kontaktowe",
				Name: "Nazwa",
				Consumer: "Konsument",
				NIP: "NIP",
				Identifier: "Identyfikator",
				"Owner data": {
					Title: "Dane właściciela klienta końcowego",
					Login: "Login",
					Name: "Imię",
					"Last name": "Nazwisko",
					Phone: "Telefon",
					Email: "Email",
				},
				Contact: {
					Email: "E-mail",
					"Email for send": "E-mail do wysyłki",
					Phone: "Telefon",
					"Contact person": "Osoba do kontaktu",
				},
				Address: {
					City: "Miasto",
					Street: "Ulica",
					PostCode: "Kod pocztowy",
				},
				"Address for corespondence": {
					City: "Miasto",
					Street: "Ulica",
					PostCode: "Kod pocztowy",
				},
			},

			Table: {
				Customer: "Klient",
				Id: "Identyfikator",
				"Creation date": "Data utworzenia",
				NIP: "NIP",
				Actions: "Akcje",
				Infoshare: "Możliwość łączenia kont",
				"Actions Unblock": "Odblokuj łączenie kont",
				Details: "Szczegóły klienta końcowego",
			},
		},

		Validators: {
			"Field required": "Pole jest wymagane",
			"File must be image": "Plik musi być obrazkiem",
			"File must be must be less than 2MB": "Plik musi być mniejszy niż 2MB",
			"E-mail must be valid": "E-mail jest niepoprawny",
			"Url must be valid": "Url jest niepoprawny",
			"Phone must be valid": "Numer telefonu jest niepoprawny",
			"Identifier exists": "Identyfikator jest już zajęty",
			"NIP exists": "NIP jest już zajęty",
			"Identifier cannot be verified":
				"Identyfikator nie może być zweryfikowany",
			"NIP cannot be verified": "NIP nie może być zweryfikowane",
			"NIP must be valid": "NIP jest niepoprawny",
			"Operation failed": "Operacja nie udała się",
			"Passwords must be the same": "Hasła muszą być takie same",
			"Password must be valid": "Hasło jest nieprawidłowe",
			"Password cannot be verified": "Hasło nie może być zweryfikowane",

			Password: {
				isValidPasswordMinLength: "Niepoprawna długość hasła",
				isValidPasswordMaxRetention: "Niepoprawna retencja hasła",
				isValidPasswordHighComplexity: "Niepoprawna złożoność hasła",
				isValidPasswordCanContainsUserName: "Hasło zawiera nazwę użytkownika",
			},
		},

		Modules: {
			INVOICE: "Faktury",
			PAYMENTS: "Płatności",
			BALANCE: "Salda",
			MARKETING: "Marketing",
			MOBILE_APP: "Aplikacja mobilna",
		},

		DocumentStatus: {
			NEW: "Nowy",
			DOWNLOADED: "Pobrany",
		},

		DocumentType: {
			INVOICE: "Faktura",
			INVOICE_CORRECTION: "Faktura korygująca",
		},

		Reports: {
			Authentications: {
				"Login date": "Data logowania",
				"Date from": "Data od",
				"Date to": "Data do",
				Table: {
					"Login date": "Data logowania",
					NIP: "NIP",
					Identifier: "Identyfikator",
					"Last login account":
						"Konto/subkonto z któego nastąpiło ostatnie logowanie",
					"IP Address": "Adres IP",
				},
			},

			Documents: {
				"Creation date": "Data utworzenia",
				"Date from": "Data od",
				"Date to": "Data do",
				Table: {
					"Creation date": "Data utworzenia",
					"First download date": "Data odczytania/pobrania dokumentu",
					"Invoice date": "Data wystawienia dokumentu",
					Identifier: "Identyfikator",
					NIP: "NIP",
					"Document number": "Numer dokumentu",
					"Payment date": "Termin płatności",
					"Gross amount": "Kwota brutto",
					"Document type": "Rodzaj dokumentu",
					"Document status": "Status dokumentu",
				},
			},

			Messages: {
				Date: "Data",
				"Date from": "Data od",
				"Date to": "Data do",
				Table: {
					Date: "Data zapoznania się/zatwierdzenia",
					Identifier: "Identyfikator",
					NIP: "NIP",
					Name: "Nazwa",
					"User type": "Typ konta",
					"User login": "Login użytkownika",
					Status: "Status komunikatu",
					"IP Address": "Adres IP",
					MessageId: "Id",
					SubjectType: "Typ",
					ServiceType: "Rodzaj",
				},
			},
		},

		"User form": {
			"Password confirmation": "Hasło (powtórzenie)",
		},
		MailTemplate: {
			Header: "Konfiguracja Email",
			"Form title": "Tytuł",
			"Form margin color": "Kolor marginesu",
			"Form image file id": "Id pliku",
			"Form image file min width 600px":
				"Zalecana minimalna szerokość obrazka 600px",
			"Form salutation text": "Treść powitania",
			"Form closing text": "Treść zakończenia",
			"Form legal note": "Treść noty prawnej",
			"Form legal note color": "Kolor tła noty prawnej",
			"Form email test": "Email test",
			"Email test success": "Testowy email został wysłany",
			"Email test error": "Nie udało się wysłać emaila",
			"Test email": "Email na który zostanie wysłany email testowy",
		},
	},

	Messages: {
		"Auth code form": {
			"Code error": "Nieprawidłowy kod autoryzacyjny",
			"Code send": "Kod autoryzacyjny został wysłany",
			"Sent new code": "Wysłano nowy kod autoryzacyjny",
			Remember: "Zapamiętaj",
		},

		Common: {
			"Password changed": "Hasło zmienione",
			"Data saved": "Dane zapisane",
			Sent: "Wysłano",
			"Confirm delete": "Czy wykasować ?",
			Unblock: "Odblokowano",
			"Server error": "Błąd serwera",
		},

		"Login form": {
			"Password is required": "Hasło jest wymagane",
			"Login is required": "Login jest wymagany",
			"Login must be valid": "Login musi byc poprawny",
			"Login failed": "Nie udało się zalogować",
			"User Blocked": "Konto zablokowane, skontaktuj się z administratorem",
		},

		Customeruser: {
			"Account details": {
				"User exists": "Użytkownik o takim loginie już istnieje",
				"Customer user owner exists": "Użytkownik właściciel już istnieje",
			},
		},

		Home: {
			"Arise error": "Wystąpił błąd!",
			"Welcome header": "Witamy w portalu wymiany dokumentów connectee.pl !",
			"Welcome subheader":
				"Twoje zainteresowanie naszą platformą, świadczy o tym, że jakość środowiska w jakim żyjemy nie jest Ci obojętna, a w digitalizacji procesów lub dokumentów widzisz potrzebę lub szansę dla swojej organizacji?",
			"Welcome text before link":
				"Zacznij już teraz! Skontaktuj się z nami, aby rozpocząć korzystanie z platformy wymiany dokumentów connectee.pl. Wejdź na stronę",
			"Welcome text after link": "i wypełnij formularz kontaktowy.",
			"Welcome paragraph":
				"Odezwiemy się tak szybko jak to tylko możliwe. Do usłyszenia!",
			"Team Innovation Technologies Group":
				"Zespół Innovation Technologies Group",
			"Please log in to your domain":
				"Bardzo prosimy o zalogowanie się do swojej domeny",
		},

		Messages: {
			"Add message error": "Nie udało się dodac komunikatu",
			"Update error": "Nie można zaktualizować komunikatu",
		},

		Cookies: {
			"The website uses cookies to provide services in accordance with":
				"Strona korzysta z plików cookie w celu realizacji usług zgodnie z",
			"Cookies policy": "Polityką Cookies",
			"You can define the conditions for storing or accessing the cookie mechanism in your browser":
				" Możesz określić warunki przechowywania lub dostępu mechanizmu cookie w Twojej przeglądarce",
		},
	},

	devex: {
		Yes: "Yes",
		No: "No",
		Cancel: "Anuluj",
		Clear: "Clear",
		Done: "Done",
		Loading: "Loading...",
		Select: "Select...",
		Search: "Search",
		Back: "Back",
		OK: "OK",

		"dxCollectionWidget-noDataText": "Brak danych do wyświetlenia",

		"dxDropDownEditor-selectLabel": "Select",

		"validation-required": "Required",
		"validation-required-formatted": "{0} is required",
		"validation-numeric": "Value must be a number",
		"validation-numeric-formatted": "{0} must be a number",
		"validation-range": "Value is out of range",
		"validation-range-formatted": "{0} is out of range",
		"validation-stringLength": "The length of the value is not correct",
		"validation-stringLength-formatted": "The length of {0} is not correct",
		"validation-custom": "Value is invalid",
		"validation-custom-formatted": "{0} is invalid",
		"validation-async": "Value is invalid",
		"validation-async-formatted": "{0} is invalid",
		"validation-compare": "Values do not match",
		"validation-compare-formatted": "{0} does not match",
		"validation-pattern": "Value does not match pattern",
		"validation-pattern-formatted": "{0} does not match pattern",
		"validation-email": "Email is invalid",
		"validation-email-formatted": "{0} is invalid",
		"validation-mask": "Value is invalid",

		"dxLookup-searchPlaceholder": "Minimum character number: {0}",

		"dxList-pullingDownText": "Pull down to refresh...",
		"dxList-pulledDownText": "Release to refresh...",
		"dxList-refreshingText": "Refreshing...",
		"dxList-pageLoadingText": "Loading...",
		"dxList-nextButtonText": "More",
		"dxList-selectAll": "Wybierz wszystkie",
		"dxListEditDecorator-delete": "Delete",
		"dxListEditDecorator-more": "More",

		"dxScrollView-pullingDownText": "Pull down to refresh...",
		"dxScrollView-pulledDownText": "Release to refresh...",
		"dxScrollView-refreshingText": "Refreshing...",
		"dxScrollView-reachBottomText": "Loading...",

		"dxDateBox-simulatedDataPickerTitleTime": "Select time",
		"dxDateBox-simulatedDataPickerTitleDate": "Select date",
		"dxDateBox-simulatedDataPickerTitleDateTime": "Select date and time",
		"dxDateBox-validation-datetime": "Value must be a date or time",

		"dxFileUploader-selectFile": "Select file",
		"dxFileUploader-dropFile": "or Drop file here",
		"dxFileUploader-bytes": "bytes",
		"dxFileUploader-kb": "kb",
		"dxFileUploader-Mb": "Mb",
		"dxFileUploader-Gb": "Gb",
		"dxFileUploader-upload": "Upload",
		"dxFileUploader-uploaded": "Uploaded",
		"dxFileUploader-readyToUpload": "Ready to upload",
		"dxFileUploader-uploadAbortedMessage": "Upload cancelled",
		"dxFileUploader-uploadFailedMessage": "Upload failed",
		"dxFileUploader-invalidFileExtension": "File type is not allowed",
		"dxFileUploader-invalidMaxFileSize": "File is too large",
		"dxFileUploader-invalidMinFileSize": "File is too small",

		"dxRangeSlider-ariaFrom": "From",
		"dxRangeSlider-ariaTill": "Till",
		"dxSwitch-switchedOnText": "ON",
		"dxSwitch-switchedOffText": "OFF",

		"dxForm-optionalMark": "optional",
		"dxForm-requiredMessage": "{0} is required",

		"dxNumberBox-invalidValueMessage": "Value must be a number",
		"dxNumberBox-noDataText": "No data",

		"dxDataGrid-columnChooserTitle": "Wybierz kolumny",
		"dxDataGrid-columnChooserEmptyText":
			"Przeciągnij kolumnę tutaj, aby ją ukryć",
		"dxDataGrid-groupContinuesMessage": "Continues on the next page",
		"dxDataGrid-groupContinuedMessage": "Continued from the previous page",
		"dxDataGrid-groupHeaderText": "Group by This Column",
		"dxDataGrid-ungroupHeaderText": "Ungroup",
		"dxDataGrid-ungroupAllText": "Ungroup All",
		"dxDataGrid-editingEditRow": "Edit",
		"dxDataGrid-editingSaveRowChanges": "Save",
		"dxDataGrid-editingCancelRowChanges": "Anuluj",
		"dxDataGrid-editingDeleteRow": "Delete",
		"dxDataGrid-editingUndeleteRow": "Undelete",
		"dxDataGrid-editingConfirmDeleteMessage":
			"Are you sure you want to delete this record?",
		"dxDataGrid-validationCancelChanges": "Cancel changes",
		"dxDataGrid-groupPanelEmptyText":
			"Przeciągnij nagłówek kolumny tutaj, aby pogrupować według tej kolumny",
		"dxDataGrid-noDataText": "No data",
		"dxDataGrid-searchPanelPlaceholder": "Search...",
		"dxDataGrid-filterRowShowAllText": "(All)",
		"dxDataGrid-filterRowResetOperationText": "Reset",
		"dxDataGrid-filterRowOperationEquals": "Równe",
		"dxDataGrid-filterRowOperationNotEquals": "Różne",
		"dxDataGrid-filterRowOperationLess": "Mniejsze niż",
		"dxDataGrid-filterRowOperationLessOrEquals": "Mniejsze lub równe",
		"dxDataGrid-filterRowOperationGreater": "Większe niż",
		"dxDataGrid-filterRowOperationGreaterOrEquals": "Większe lub równe",
		"dxDataGrid-filterRowOperationStartsWith": "Zaczyna się od",
		"dxDataGrid-filterRowOperationContains": "Zawiera",
		"dxDataGrid-filterRowOperationNotContains": "Nie zawiera",
		"dxDataGrid-filterRowOperationEndsWith": "Kończy się",
		"dxDataGrid-filterRowOperationBetween": "Pomiędzy",
		"dxDataGrid-filterRowOperationBetweenStartText": "Zaczyna",
		"dxDataGrid-filterRowOperationBetweenEndText": "Kończy",
		"dxDataGrid-applyFilterText": "Apply filter",
		"dxDataGrid-trueText": "true",
		"dxDataGrid-falseText": "false",
		"dxDataGrid-sortingAscendingText": "Sort Ascending",
		"dxDataGrid-sortingDescendingText": "Sort Descending",
		"dxDataGrid-sortingClearText": "Clear Sorting",
		"dxDataGrid-editingSaveAllChanges": "Save changes",
		"dxDataGrid-editingCancelAllChanges": "Discard changes",
		"dxDataGrid-editingAddRow": "Add a row",
		"dxDataGrid-summaryMin": "Min: {0}",
		"dxDataGrid-summaryMinOtherColumn": "Min of {1} is {0}",
		"dxDataGrid-summaryMax": "Max: {0}",
		"dxDataGrid-summaryMaxOtherColumn": "Max of {1} is {0}",
		"dxDataGrid-summaryAvg": "Avg: {0}",
		"dxDataGrid-summaryAvgOtherColumn": "Avg of {1} is {0}",
		"dxDataGrid-summarySum": "Sum: {0}",
		"dxDataGrid-summarySumOtherColumn": "Sum of {1} is {0}",
		"dxDataGrid-summaryCount": "Count: {0}",
		"dxDataGrid-columnFixingFix": "Fix",
		"dxDataGrid-columnFixingUnfix": "Unfix",
		"dxDataGrid-columnFixingLeftPosition": "To the left",
		"dxDataGrid-columnFixingRightPosition": "To the right",
		"dxDataGrid-exportTo": "Export",
		"dxDataGrid-exportToExcel": "Export to Excel file",
		"dxDataGrid-exporting": "Exporting...",
		"dxDataGrid-excelFormat": "Excel file",
		"dxDataGrid-selectedRows": "Selected rows",
		"dxDataGrid-exportSelectedRows": "Export selected rows",
		"dxDataGrid-exportAll": "Export all data",
		"dxDataGrid-headerFilterEmptyValue": "(Blanks)",
		"dxDataGrid-headerFilterOK": "OK",
		"dxDataGrid-headerFilterCancel": "Anuluj",
		"dxDataGrid-ariaColumn": "Column",
		"dxDataGrid-ariaValue": "Value",
		"dxDataGrid-ariaFilterCell": "Filter cell",
		"dxDataGrid-ariaCollapse": "Collapse",
		"dxDataGrid-ariaExpand": "Expand",
		"dxDataGrid-ariaDataGrid": "Data grid",
		"dxDataGrid-ariaSearchInGrid": "Search in data grid",
		"dxDataGrid-ariaSelectAll": "Zaznacz wszystkie",
		"dxDataGrid-ariaSelectRow": "Select row",
		"dxDataGrid-filterBuilderPopupTitle": "Filter Builder",
		"dxDataGrid-filterPanelCreateFilter": "Create Filter",
		"dxDataGrid-filterPanelClearFilter": "Clear",
		"dxDataGrid-filterPanelFilterEnabledHint": "Enable the filter",

		"dxTreeList-ariaTreeList": "Tree list",
		"dxTreeList-editingAddRowToNode": "Add",

		"dxPager-infoText": "Page {0} of {1} ({2} items)",
		"dxPager-pagesCountText": "of",
		"dxPager-pageSizesAllText": "All",

		"dxPivotGrid-grandTotal": "Grand Total",
		"dxPivotGrid-total": "{0} Total",
		"dxPivotGrid-fieldChooserTitle": "Field Chooser",
		"dxPivotGrid-showFieldChooser": "Show Field Chooser",
		"dxPivotGrid-expandAll": "Expand All",
		"dxPivotGrid-collapseAll": "Collapse All",
		"dxPivotGrid-sortColumnBySummary": 'Sort "{0}" by This Column',
		"dxPivotGrid-sortRowBySummary": 'Sort "{0}" by This Row',
		"dxPivotGrid-removeAllSorting": "Remove All Sorting",
		"dxPivotGrid-dataNotAvailable": "N/A",
		"dxPivotGrid-rowFields": "Row Fields",
		"dxPivotGrid-columnFields": "Column Fields",
		"dxPivotGrid-dataFields": "Data Fields",
		"dxPivotGrid-filterFields": "Filter Fields",
		"dxPivotGrid-allFields": "All Fields",
		"dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
		"dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
		"dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
		"dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",

		"dxScheduler-editorLabelTitle": "Subject",
		"dxScheduler-editorLabelStartDate": "Start Date",
		"dxScheduler-editorLabelEndDate": "End Date",
		"dxScheduler-editorLabelDescription": "Description",
		"dxScheduler-editorLabelRecurrence": "Repeat",

		"dxScheduler-openAppointment": "Open appointment",

		"dxScheduler-recurrenceNever": "Never",
		"dxScheduler-recurrenceMinutely": "Every minute",
		"dxScheduler-recurrenceHourly": "Hourly",
		"dxScheduler-recurrenceDaily": "Daily",
		"dxScheduler-recurrenceWeekly": "Weekly",
		"dxScheduler-recurrenceMonthly": "Monthly",
		"dxScheduler-recurrenceYearly": "Yearly",

		"dxScheduler-recurrenceRepeatEvery": "Repeat Every",
		"dxScheduler-recurrenceRepeatOn": "Repeat On",
		"dxScheduler-recurrenceEnd": "End repeat",
		"dxScheduler-recurrenceAfter": "After",
		"dxScheduler-recurrenceOn": "On",

		"dxScheduler-recurrenceRepeatMinutely": "minute(s)",
		"dxScheduler-recurrenceRepeatHourly": "hour(s)",
		"dxScheduler-recurrenceRepeatDaily": "day(s)",
		"dxScheduler-recurrenceRepeatWeekly": "week(s)",
		"dxScheduler-recurrenceRepeatMonthly": "month(s)",
		"dxScheduler-recurrenceRepeatYearly": "year(s)",

		"dxScheduler-switcherDay": "Day",
		"dxScheduler-switcherWeek": "Week",
		"dxScheduler-switcherWorkWeek": "Work Week",
		"dxScheduler-switcherMonth": "Month",

		"dxScheduler-switcherAgenda": "Agenda",

		"dxScheduler-switcherTimelineDay": "Timeline Day",
		"dxScheduler-switcherTimelineWeek": "Timeline Week",
		"dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
		"dxScheduler-switcherTimelineMonth": "Timeline Month",

		"dxScheduler-recurrenceRepeatOnDate": "on date",
		"dxScheduler-recurrenceRepeatCount": "occurrence(s)",
		"dxScheduler-allDay": "All day",

		"dxScheduler-confirmRecurrenceEditMessage":
			"Do you want to edit only this appointment or the whole series?",
		"dxScheduler-confirmRecurrenceDeleteMessage":
			"Do you want to delete only this appointment or the whole series?",

		"dxScheduler-confirmRecurrenceEditSeries": "Edit series",
		"dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
		"dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
		"dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",

		"dxScheduler-noTimezoneTitle": "No timezone",
		"dxScheduler-moreAppointments": "{0} more",

		"dxCalendar-todayButtonText": "Today",
		"dxCalendar-ariaWidgetName": "Calendar",

		"dxColorView-ariaRed": "Red",
		"dxColorView-ariaGreen": "Green",
		"dxColorView-ariaBlue": "Blue",
		"dxColorView-ariaAlpha": "Transparency",
		"dxColorView-ariaHex": "Color code",

		"dxTagBox-selected": "{0} selected",
		"dxTagBox-allSelected": "All selected ({0})",
		"dxTagBox-moreSelected": "{0} more",

		"vizExport-printingButtonText": "Print",
		"vizExport-titleMenuText": "Exporting/Printing",
		"vizExport-exportButtonText": "{0} file",

		"dxFilterBuilder-and": "And",
		"dxFilterBuilder-or": "Or",
		"dxFilterBuilder-notAnd": "Not And",
		"dxFilterBuilder-notOr": "Not Or",
		"dxFilterBuilder-addCondition": "Add Condition",
		"dxFilterBuilder-addGroup": "Add Group",
		"dxFilterBuilder-enterValueText": "<enter a value>",
		"dxFilterBuilder-filterOperationEquals": "Equals",
		"dxFilterBuilder-filterOperationNotEquals": "Does not equal",
		"dxFilterBuilder-filterOperationLess": "Is less than",
		"dxFilterBuilder-filterOperationLessOrEquals": "Is less than or equal to",
		"dxFilterBuilder-filterOperationGreater": "Is greater than",
		"dxFilterBuilder-filterOperationGreaterOrEquals":
			"Is greater than or equal to",
		"dxFilterBuilder-filterOperationStartsWith": "Zaczyna się od",
		"dxFilterBuilder-filterOperationContains": "Zawiera",
		"dxFilterBuilder-filterOperationNotContains": "Nie zawiera",
		"dxFilterBuilder-filterOperationEndsWith": "Kończy się",
		"dxFilterBuilder-filterOperationIsBlank": "Is blank",
		"dxFilterBuilder-filterOperationIsNotBlank": "Is not blank",
		"dxFilterBuilder-filterOperationBetween": "Is between",
		"dxFilterBuilder-filterOperationAnyOf": "Is any of",
		"dxFilterBuilder-filterOperationNoneOf": "Is none of",

		"dxHtmlEditor-dialogColorCaption": "Change Font Color",
		"dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
		"dxHtmlEditor-dialogLinkCaption": "Add Link",
		"dxHtmlEditor-dialogLinkUrlField": "URL",
		"dxHtmlEditor-dialogLinkTextField": "Text",
		"dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
		"dxHtmlEditor-dialogImageCaption": "Add Image",
		"dxHtmlEditor-dialogImageUrlField": "URL",
		"dxHtmlEditor-dialogImageAltField": "Alternate text",
		"dxHtmlEditor-dialogImageWidthField": "Width (px)",
		"dxHtmlEditor-dialogImageHeightField": "Height (px)",
		"dxHtmlEditor-dialogInsertTableRowsField": "Rows",
		"dxHtmlEditor-dialogInsertTableColumnsField": "Columns",
		"dxHtmlEditor-dialogInsertTableCaption": "Insert Table",
		"dxHtmlEditor-heading": "Heading",
		"dxHtmlEditor-normalText": "Normal text",

		"dxFileManager-newDirectoryName": "Untitled directory",
		"dxFileManager-rootDirectoryName": "Files",
		"dxFileManager-errorNoAccess":
			"Access Denied. Operation could not be completed.",
		"dxFileManager-errorDirectoryExistsFormat":
			"Directory '{0}' already exists.",
		"dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
		"dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
		"dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
		"dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
		"dxFileManager-errorMaxFileSizeExceeded":
			"File size exceeds the maximum allowed size.",
		"dxFileManager-errorInvalidSymbols":
			"This name contains invalid characters.",
		"dxFileManager-errorDefault": "Unspecified error.",
		"dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",

		"dxFileManager-commandCreate": "New directory",
		"dxFileManager-commandRename": "Rename",
		"dxFileManager-commandMove": "Move to",
		"dxFileManager-commandCopy": "Copy to",
		"dxFileManager-commandDelete": "Delete",
		"dxFileManager-commandDownload": "Download",
		"dxFileManager-commandUpload": "Upload files",
		"dxFileManager-commandRefresh": "Refresh",
		"dxFileManager-commandThumbnails": "Thumbnails View",
		"dxFileManager-commandDetails": "Details View",
		"dxFileManager-commandClearSelection": "Clear selection",
		"dxFileManager-commandShowNavPane": "Toggle navigation pane",

		"dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
		"dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
		"dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
		"dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
		"dxFileManager-dialogRenameItemTitle": "Rename",
		"dxFileManager-dialogRenameItemButtonText": "Save",
		"dxFileManager-dialogCreateDirectoryTitle": "New directory",
		"dxFileManager-dialogCreateDirectoryButtonText": "Create",
		"dxFileManager-dialogDeleteItemTitle": "Delete",
		"dxFileManager-dialogDeleteItemButtonText": "Delete",
		"dxFileManager-dialogDeleteItemSingleItemConfirmation":
			"Are you sure you want to delete {0}?",
		"dxFileManager-dialogDeleteItemMultipleItemsConfirmation":
			"Are you sure you want to delete {0} items?",
		"dxFileManager-dialogButtonCancel": "Anuluj",

		"dxFileManager-editingCreateSingleItemProcessingMessage":
			"Creating a directory inside {0}",
		"dxFileManager-editingCreateSingleItemSuccessMessage":
			"Created a directory inside {0}",
		"dxFileManager-editingCreateSingleItemErrorMessage":
			"Directory was not created",
		"dxFileManager-editingCreateCommonErrorMessage":
			"Directory was not created",

		"dxFileManager-editingRenameSingleItemProcessingMessage":
			"Renaming an item inside {0}",
		"dxFileManager-editingRenameSingleItemSuccessMessage":
			"Renamed an item inside {0}",
		"dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
		"dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",

		"dxFileManager-editingDeleteSingleItemProcessingMessage":
			"Deleting an item from {0}",
		"dxFileManager-editingDeleteMultipleItemsProcessingMessage":
			"Deleting {0} items from {1}",
		"dxFileManager-editingDeleteSingleItemSuccessMessage":
			"Deleted an item from {0}",
		"dxFileManager-editingDeleteMultipleItemsSuccessMessage":
			"Deleted {0} items from {1}",
		"dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
		"dxFileManager-editingDeleteMultipleItemsErrorMessage":
			"{0} items were not deleted",
		"dxFileManager-editingDeleteCommonErrorMessage":
			"Some items were not deleted",

		"dxFileManager-editingMoveSingleItemProcessingMessage":
			"Moving an item to {0}",
		"dxFileManager-editingMoveMultipleItemsProcessingMessage":
			"Moving {0} items to {1}",
		"dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
		"dxFileManager-editingMoveMultipleItemsSuccessMessage":
			"Moved {0} items to {1}",
		"dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
		"dxFileManager-editingMoveMultipleItemsErrorMessage":
			"{0} items were not moved",
		"dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",

		"dxFileManager-editingCopySingleItemProcessingMessage":
			"Copying an item to {0}",
		"dxFileManager-editingCopyMultipleItemsProcessingMessage":
			"Copying {0} items to {1}",
		"dxFileManager-editingCopySingleItemSuccessMessage":
			"Copied an item to {0}",
		"dxFileManager-editingCopyMultipleItemsSuccessMessage":
			"Copied {0} items to {1}",
		"dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
		"dxFileManager-editingCopyMultipleItemsErrorMessage":
			"{0} items were not copied",
		"dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",

		"dxFileManager-editingUploadSingleItemProcessingMessage":
			"Uploading an item to {0}",
		"dxFileManager-editingUploadMultipleItemsProcessingMessage":
			"Uploading {0} items to {1}",
		"dxFileManager-editingUploadSingleItemSuccessMessage":
			"Uploaded an item to {0}",
		"dxFileManager-editingUploadMultipleItemsSuccessMessage":
			"Uploaded {0} items to {1}",
		"dxFileManager-editingUploadSingleItemErrorMessage":
			"Item was not uploaded",
		"dxFileManager-editingUploadMultipleItemsErrorMessage":
			"{0} items were not uploaded",
		"dxFileManager-editingUploadCanceledMessage": "Canceled",

		"dxFileManager-listDetailsColumnCaptionName": "Name",
		"dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
		"dxFileManager-listDetailsColumnCaptionFileSize": "File Size",

		"dxFileManager-listThumbnailsTooltipTextSize": "Size",
		"dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",

		"dxFileManager-notificationProgressPanelTitle": "Progress",
		"dxFileManager-notificationProgressPanelEmptyListText": "No operations",
		"dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",

		"dxDiagram-categoryGeneral": "General",
		"dxDiagram-categoryFlowchart": "Flowchart",
		"dxDiagram-categoryOrgChart": "Org Chart",
		"dxDiagram-categoryContainers": "Containers",
		"dxDiagram-categoryCustom": "Custom",

		"dxDiagram-commandExportToSvg": "Export to SVG",
		"dxDiagram-commandExportToPng": "Export to PNG",
		"dxDiagram-commandExportToJpg": "Export to JPEG",
		"dxDiagram-commandUndo": "Undo",
		"dxDiagram-commandRedo": "Redo",
		"dxDiagram-commandFontName": "Font Name",
		"dxDiagram-commandFontSize": "Font Size",
		"dxDiagram-commandBold": "Bold",
		"dxDiagram-commandItalic": "Italic",
		"dxDiagram-commandUnderline": "Underline",
		"dxDiagram-commandTextColor": "Font Color",
		"dxDiagram-commandLineColor": "Line Color",
		"dxDiagram-commandLineWidth": "Line Width",
		"dxDiagram-commandLineStyle": "Line Style",
		"dxDiagram-commandLineStyleSolid": "Solid",
		"dxDiagram-commandLineStyleDotted": "Dotted",
		"dxDiagram-commandLineStyleDashed": "Dashed",
		"dxDiagram-commandFillColor": "Fill Color",
		"dxDiagram-commandAlignLeft": "Align Left",
		"dxDiagram-commandAlignCenter": "Align Center",
		"dxDiagram-commandAlignRight": "Align Right",
		"dxDiagram-commandConnectorLineType": "Connector Line Type",
		"dxDiagram-commandConnectorLineStraight": "Straight",
		"dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
		"dxDiagram-commandConnectorLineStart": "Connector Line Start",
		"dxDiagram-commandConnectorLineEnd": "Connector Line End",
		"dxDiagram-commandConnectorLineNone": "None",
		"dxDiagram-commandConnectorLineArrow": "Arrow",
		"dxDiagram-commandFullscreen": "Full Screen",
		"dxDiagram-commandUnits": "Units",
		"dxDiagram-commandPageSize": "Page Size",
		"dxDiagram-commandPageOrientation": "Page Orientation",
		"dxDiagram-commandPageOrientationLandscape": "Landscape",
		"dxDiagram-commandPageOrientationPortrait": "Portrait",
		"dxDiagram-commandPageColor": "Page Color",
		"dxDiagram-commandShowGrid": "Show Grid",
		"dxDiagram-commandSnapToGrid": "Snap to Grid",
		"dxDiagram-commandGridSize": "Grid Size",
		"dxDiagram-commandZoomLevel": "Zoom Level",
		"dxDiagram-commandAutoZoom": "Auto Zoom",
		"dxDiagram-commandFitToContent": "Fit to Content",
		"dxDiagram-commandFitToWidth": "Fit to Width",
		"dxDiagram-commandAutoZoomByContent": "Auto Zoom by Content",
		"dxDiagram-commandAutoZoomByWidth": "Auto Zoom by Width",
		"dxDiagram-commandSimpleView": "Simple View",
		"dxDiagram-commandCut": "Cut",
		"dxDiagram-commandCopy": "Copy",
		"dxDiagram-commandPaste": "Paste",
		"dxDiagram-commandSelectAll": "Wybierz wszystkie",
		"dxDiagram-commandDelete": "Delete",
		"dxDiagram-commandBringToFront": "Bring to Front",
		"dxDiagram-commandSendToBack": "Send to Back",
		"dxDiagram-commandLock": "Lock",
		"dxDiagram-commandUnlock": "Unlock",
		"dxDiagram-commandInsertShapeImage": "Insert Image...",
		"dxDiagram-commandEditShapeImage": "Change Image...",
		"dxDiagram-commandDeleteShapeImage": "Delete Image",
		"dxDiagram-commandLayoutLeftToRight": "Left-to-right",
		"dxDiagram-commandLayoutRightToLeft": "Right-to-left",
		"dxDiagram-commandLayoutTopToBottom": "Top-to-bottom",
		"dxDiagram-commandLayoutBottomToTop": "Bottom-to-top",

		"dxDiagram-unitIn": "in",
		"dxDiagram-unitCm": "cm",
		"dxDiagram-unitPx": "px",

		"dxDiagram-dialogButtonOK": "OK",
		"dxDiagram-dialogButtonCancel": "Anuluj",
		"dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
		"dxDiagram-dialogEditShapeImageTitle": "Change Image",
		"dxDiagram-dialogEditShapeImageSelectButton": "Select image",
		"dxDiagram-dialogEditShapeImageLabelText": "or drop file here",

		"dxDiagram-uiExport": "Export",
		"dxDiagram-uiProperties": "Properties",
		"dxDiagram-uiSettings": "Settings",
		"dxDiagram-uiShowToolbox": "Show Toolbox",
		"dxDiagram-uiSearch": "Search",
		"dxDiagram-uiStyle": "Style",
		"dxDiagram-uiLayout": "Layout",
		"dxDiagram-uiLayoutTree": "Tree",
		"dxDiagram-uiLayoutLayered": "Layered",
		"dxDiagram-uiDiagram": "Diagram",
		"dxDiagram-uiText": "Text",
		"dxDiagram-uiObject": "Object",
		"dxDiagram-uiConnector": "Connector",
		"dxDiagram-uiPage": "Page",

		"dxDiagram-shapeText": "Text",
		"dxDiagram-shapeRectangle": "Rectangle",
		"dxDiagram-shapeEllipse": "Ellipse",
		"dxDiagram-shapeCross": "Cross",
		"dxDiagram-shapeTriangle": "Triangle",
		"dxDiagram-shapeDiamond": "Diamond",
		"dxDiagram-shapeHeart": "Heart",
		"dxDiagram-shapePentagon": "Pentagon",
		"dxDiagram-shapeHexagon": "Hexagon",
		"dxDiagram-shapeOctagon": "Octagon",
		"dxDiagram-shapeStar": "Star",
		"dxDiagram-shapeArrowLeft": "Left Arrow",
		"dxDiagram-shapeArrowUp": "Up Arrow",
		"dxDiagram-shapeArrowRight": "Right Arrow",
		"dxDiagram-shapeArrowDown": "Down Arrow",
		"dxDiagram-shapeArrowUpDown": "Up Down Arrow",
		"dxDiagram-shapeArrowLeftRight": "Left Right Arrow",
		"dxDiagram-shapeProcess": "Process",
		"dxDiagram-shapeDecision": "Decision",
		"dxDiagram-shapeTerminator": "Terminator",
		"dxDiagram-shapePredefinedProcess": "Predefined Process",
		"dxDiagram-shapeDocument": "Document",
		"dxDiagram-shapeMultipleDocuments": "Multiple Documents",
		"dxDiagram-shapeManualInput": "Manual Input",
		"dxDiagram-shapePreparation": "Preparation",
		"dxDiagram-shapeData": "Data",
		"dxDiagram-shapeDatabase": "Database",
		"dxDiagram-shapeHardDisk": "Hard Disk",
		"dxDiagram-shapeInternalStorage": "Internal Storage",
		"dxDiagram-shapePaperTape": "Paper Tape",
		"dxDiagram-shapeManualOperation": "Manual Operation",
		"dxDiagram-shapeDelay": "Delay",
		"dxDiagram-shapeStoredData": "Stored Data",
		"dxDiagram-shapeDisplay": "Display",
		"dxDiagram-shapeMerge": "Merge",
		"dxDiagram-shapeConnector": "Connector",
		"dxDiagram-shapeOr": "Or",
		"dxDiagram-shapeSummingJunction": "Summing Junction",
		"dxDiagram-shapeContainerDefaultText": "Container",
		"dxDiagram-shapeVerticalContainer": "Vertical Container",
		"dxDiagram-shapeHorizontalContainer": "Horizontal Container",
		"dxDiagram-shapeCardDefaultText": "Person's Name",
		"dxDiagram-shapeCardWithImageOnLeft": "Card with Image on the Left",
		"dxDiagram-shapeCardWithImageOnTop": "Card with Image on the Top",
		"dxDiagram-shapeCardWithImageOnRight": "Card with Image on the Right",

		"dxGantt-dialogTitle": "Title",
		"dxGantt-dialogStartTitle": "Start",
		"dxGantt-dialogEndTitle": "End",
		"dxGantt-dialogProgressTitle": "Progress",
		"dxGantt-dialogResourcesTitle": "Resources",
		"dxGantt-dialogResourceManagerTitle": "Resource Manager",
		"dxGantt-dialogTaskDetailsTitle": "Task Details",
		"dxGantt-dialogEditResourceListHint": "Edit Resource List",
		"dxGantt-dialogEditNoResources": "No resources",
		"dxGantt-dialogButtonAdd": "Add",
		"dxGantt-contextMenuNewTask": "New Task",
		"dxGantt-contextMenuNewSubtask": "New Subtask",
		"dxGantt-contextMenuDeleteTask": "Delete Task",
		"dxGantt-contextMenuDeleteDependency": "Delete Dependency",
		"dxGantt-dialogTaskDeleteConfirmation":
			"Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?",
		"dxGantt-dialogDependencyDeleteConfirmation":
			"Are you sure you want to delete the dependency from the task?",
		"dxGantt-dialogResourcesDeleteConfirmation":
			"Deleting a resource also deletes it from tasks to which this resource is assigned. Are you sure you want to delete these resources? Resource: {0}",
		"dxGantt-dialogConstraintCriticalViolationMessage":
			"The task you are attempting to move is linked to a second task by a dependency relation. This change would conflict with dependency rules. How would you like to proceed?",
		"dxGantt-dialogConstraintViolationMessage":
			"The task you are attempting to move is linked to a second task by a dependency relation. How would you like to proceed?",
		"dxGantt-dialogCancelOperationMessage": "Cancel the operation",
		"dxGantt-dialogDeleteDependencyMessage": "Delete the dependency",
		"dxGantt-dialogMoveTaskAndKeepDependencyMessage":
			"Move the task and keep the dependency",
		"dxGantt-undo": "Undo",
		"dxGantt-redo": "Redo",
		"dxGantt-expandAll": "Expand All",
		"dxGantt-collapseAll": "Collapse All",
		"dxGantt-addNewTask": "Add New Task",
		"dxGantt-deleteSelectedTask": "Delete Selected Task",
		"dxGantt-zoomIn": "Zoom In",
		"dxGantt-zoomOut": "Zoom Out",
		"dxGantt-fullScreen": "Full Screen",
	},
};
